"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const rest_url_builder_1 = require("rest-url-builder");
const url_join_1 = __importDefault(require("url-join"));
const qs = __importStar(require("query-string"));
class UriHelper {
    static resolve(params) {
        let url = url_join_1.default(params.base || "", params.path || "");
        var builder = this.urlBuilder.buildRestURL(url);
        if (params.namedQueries != undefined) {
            Object.keys(params.namedQueries).forEach(key => {
                builder.setNamedParameter(key, '' + params.namedQueries[key]);
            });
        }
        url = builder.get();
        let parsedUrl = qs.parseUrl(url);
        url = `${parsedUrl.url}?${qs.stringify(Object.assign({}, (parsedUrl.query), (params.queryStrings)))}`;
        return url;
    }
}
UriHelper.urlBuilder = new rest_url_builder_1.RestURLBuilder();
exports.default = UriHelper;
